import {UserIncident} from "../../../../domain/incident/Incident";
import React, {FC} from "react";

type Props = {
    item: UserIncident;
};

export const IncidentRowTime: FC<Props> = ({item}) => {
    const {time} = item;
    return (
        <div className={"m-0 p-0 flex flex-row flex-wrap gap-2"}>
            <span className={"text-neutral-400 font-semibold"}>HORA</span>
            <span>{time}</span>
        </div>
    );
};
